export enum INTERVIEW_PANEL_MODULE {
  APPLICATION_LIST = 'APPLICATION_LIST',
}
export enum INTERVIEW_PANEL_BUTTON {
  TO_DO = 'TO-DO',
  ALL = 'All',
}
